<template>
  <v-menu v-bind="$attrs">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :small="small" :x-small="xSmall" icon v-bind="attrs" v-on="on">
        <v-icon>{{ icon ? icon : 'mdi mdi-dots-horizontal' }}</v-icon>
      </v-btn>
    </template>
    <v-list class="py-0" dense>
      <template v-for="(item, index) in listItems">
        <v-divider v-if="index > 0" :key="item.title + '_divider'"></v-divider>
        <v-list-item :key="item.title" :disabled="!item.route && !item.action" :to="item.route && item.route"
                     class="px-3"
                     @click="handleClick(item)">
          <v-list-item-icon v-if="item.icon" class="mr-4">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "DropDownMenu",
  props: ['listItems', 'icon', 'small', 'xSmall'],
  methods: {
    routePush(route) {
      this.$router.push({
        name: route.name,
        params: route.params ? route.params : {},
      })
    },
    handleClick(item) {
      if (item.route) {
        this.routePush(item.route);
      } else {
        item.action();
      }
    }
  }
}
</script>

<style scoped>

</style>
